<template>
    <div class="home">
        <p :class="music ? 'music zhuan' : 'music'" @click="stopmusic"></p>
        <audio id="audio" loop="loop" :src="require('@/static/bgm.mp3')"></audio>
        <img src="../static/title.png" class="title" alt="">
        <img src="../static/words.png" class="thewords" alt="" v-show="thewords">
        <img src="../static/thegif.gif" class="thegif" alt="">
        <div class="words" v-html="words" v-show="show">
        </div>

        <video-player class="video-player vjs-custom-skin mp4-1" ref="mp4_1" :playsinline="true" :options="mp4_1"
            @ended="onPlayerEnded($event)" @play="onPlayerPlay($event)" @pause="onPlayerPause($event)" v-show="showmp4">
        </video-player>

        <div v-if="selectid == 0">
            <img src="../static/ewm.png" class="ewm" alt="">
            <p class="tips">扫码进入官网</p>
        </div>
        <!-- <div v-if="selectid == 2">
            <img src="../static/ewm2.png" class="ewm" alt="">
            <p class="tips">扫码进入官网</p>
        </div> -->



        <img src="../static/logo1.png" class="logo1" alt="">
        <img src="../static/logo.png" class="logo" alt="">
    </div>
</template>

<script>
export default {
    data() {
        return {
            show: false,
            showmp4: false,
            start:true,
            thewords: false,
            mp4_1: {
                playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
                autoplay: false, //如果true,浏览器准备好时开始回放。
                muted: false, // 默认情况下将会消除任何音频。
                loop: false, // 导致视频一结束就重新开始。
                preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                language: "zh-CN",
                aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                sources: [
                    {
                        type: "video/mp4", //这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
                        src: require("../static/mp4_1.mp4"), //url地址
                    },
                ],
                poster: require("../static/mp4_1.png"), //你的封面地址
                // width: document.documentElement.clientWidth, //播放器宽度
                notSupportedMessage: "此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
                controlBar: {
                    timeDivider: false, // 当前时间和持续时间的分隔符
                    durationDisplay: false, // 显示持续时间
                    remainingTimeDisplay: false, // 是否显示剩余时间功能

                    fullscreenToggle: true, //全屏按钮
                },
            },
            music: true,
            selectid: 0,
            words: '<p>(定制祝福示例)</p><p class="title-words">尊敬的客户及合作伙伴们：</p><p>在这辞旧迎新的美好时刻，[企业名称]向您及家人致以诚挚的问候与祝福！</p><p>回望过去一年，感谢您始终如一的支持与信任。每一次合作的落地、每一回沟通的往来，都让我们的脚步更稳、方向更清晰；那些一起完成的目标与成果，也成为我们共同珍藏的记忆。正因有您的陪伴与提醒，我们才能不断精进，持续向前。</p><p> 新的一年，我们将以更饱满的热忱、更专业的行动，坚守“创新、卓越、共赢”的核心价值观，持续为您奉上更优质的产品与服务。望与您策马并肩、同心同行，在新程中共迎机遇、共克挑战，让愿景落地生花，合作步履铿锵、行稳致远！</p><p>衷心祝愿您新年安康、阖家幸福，事业骏顺、万事胜意！</p><p class="end-words">——[您的名称] 敬上</p>'
        }
    },
    methods: {
        stopmusic() {
            let audio = document.getElementById("audio");
            if (this.music == true) {
                this.music = false;
                audio.pause();
            } else {
                this.music = true;
                audio.volume = 0.2

                audio.play();
            }
        },
        onPlayerPlay(e, a) {
            let audio = document.getElementById("audio");
            audio.pause();
        },
        onPlayerEnded(e) {
            console.log("播放结束", e);
            let audio = document.getElementById("audio");
 
            if (this.music == true) {
                audio.volume = 0.2;
                audio.play();

            } else {

                audio.pause();
            }

        },
        onPlayerPause(e) {
            let audio = document.getElementById("audio");


            if (this.music == true) {
                audio.volume = 0.2;
                audio.play();

            } else {

                audio.pause();
            }

        },
        androidplay() {
            if (navigator.userAgent.indexOf("Android") > 0) {
                //如果是Android的话，在判断是否是微信端打开链接
                function is_weixn() {
                    var ua = navigator.userAgent.toLowerCase();
                    if (ua.match(/MicroMessenger/i) == "micromessenger") {
                        return true;
                    } else {
                        return false;
                    }
                }
                //如果是在Android端微信打开 触摸播放
                if (is_weixn()) {
                    document.addEventListener('touchstart', () => {

                        if (this.music&&this.start) {
                            this.start=false
                            document.getElementById('audio').volume = 0.2;
                            document.getElementById('audio').play();
                        }


                    })
                } else {
                }
            }
        },

        scrolling() {
            // 滚动条距文档顶部的距离
            let scrollTop =
                window.pageYOffset ||
                document.documentElement.scrollTop ||
                document.body.scrollTop;
            // 滚动条滚动的距离
            let scrollStep = scrollTop - this.oldScrollTop;
            // console.log("header 滚动距离 ", scrollTop);
            if (scrollTop > 0 && !this.mp4) {
                if (this.music&&this.start) {
                    this.start=false
                    document.getElementById('audio').volume = 0.2
                    document.getElementById('audio').play();
                }
            }

            // 更新——滚动前，滚动条距文档顶部的距离
            this.oldScrollTop = scrollTop;

            //变量windowHeight是可视区的高度
            let windowHeight =
                document.documentElement.clientHeight || document.body.clientHeight;
            //变量scrollHeight是滚动条的总高度
            let scrollHeight =
                document.documentElement.scrollHeight || document.body.scrollHeight;

            //滚动条到底部的条件
            if (scrollTop + windowHeight == scrollHeight) {
                //你想做的事情
                console.log("header  你已经到底部了");
            }
            //   if (scrollStep < 0) {
            //     console.log("header 滚动条向上滚动了！");
            //   } else {
            //     console.log("header  滚动条向下滚动了！");
            //   }
            // 判断是否到了最顶部
            if (scrollTop <= 0) {
                console.log("header 到了最顶部")
            }
        }
    },
    mounted() {
        console.log(this.$route.query.id, "id");
        if (this.$route.query.id) {
            this.selectid = this.$route.query.id
            console.log(this.selectid, 55);

        }
        // <p></p><p class="end-words">——明呈·云泰璟园 敬上</p>
        if (this.$route.query.id == 1) {
            this.mp4_1.sources[0].src = require("../static/m1.mp4")
            this.mp4_1.poster = require("../static/m1.png")
            this.words = '<p class="title-words">亲爱的金华市民朋友们：</p><p>乙巳辞旧岁，丙午启新程。在这万象更新、暖意盈怀的美好时刻，中国铁塔金华市分公司向辛勤耕耘在八婺大地各行各业的您，向每一位热爱生活、共建家园的市民朋友，致以最诚挚的问候、最美好的祝福和最温暖的敬意！</p><p> 过去的一年，是我们与金华同心同向、共促发展的一年，是践行国企担当、深耕民生服务的一年。我们坚守“人民至上”的初心，立足铁塔存量站址资源优势，深耕绿色出行领域，以铁塔速度跑出民生服务加速度，全力破解电动车出行充电难题，为城市注入绿色动能。截至目前，我们已在全市布局665个换电网点，部署换电柜近800个，市场占有率接近50%，日均换电次数超5万次，用便捷高效的服务，守护每一次平安出行。我们深入落实“我为群众办实事”实践活动，贴心关爱新就业形态劳动者，累计建成7家铁塔换电骑手之家，为奔波在外的骑手群体提供工作生活一站式服务，让“进店即进家”成为现实，为城市劳动者打造值得信赖的温暖港湾。</p><p>每一份便捷，都凝聚着我们的坚守；每一份温暖，都离不开您的包容与支持。金华的发展，有您的奋力拼搏；铁塔的成长，有您的一路相伴。在此，我们衷心感谢全市人民的理解、信任与厚爱，是您的期盼，让我们在民生服务的道路上步履不停、奋勇前行。</p><p>新的一年，新的征程，新的希望。我们将继续坚守央企使命，深化“一体两翼”战略，立足“三个服务商”定位，持续深耕民生服务领域，优化换电网络布局，完善骑手之家服务，以更优质、更高效、更贴心的服务，回应全市人民的期盼，用实干与担当，助力数字金华、绿色金华建设，与全市人民携手共绘城市发展新蓝图。</p><p>愿马年的春风吹遍八婺大地，为您的生活带来满满暖意，为您的奋斗注入不竭动力。愿每一位金华市民身体健康、阖家幸福、万事顺遂、马到成功，愿我们共同的家园金华，更加宜居、更加美好、更加繁荣！</p><p>再次祝愿全市人民新春快乐，福暖四季，顺遂安康！</p><p class="end-words">——中国铁塔金华市分公司 敬上</p>'

       } 
         else if (this.$route.query.id == 2) {
            this.mp4_1.sources[0].src = require("../static/m2.mp4")
            this.mp4_1.poster = require("../static/m2.png")
            this.words = '<p class="title-words">亲爱的金华市民朋友们：</p><p>岁序更迭，华章日新。在这辞旧迎新的美好时刻，金华市诸暨商会迎来了成立12周年的里程碑，也迎来了第三届新领导班子的启航。在此，我们谨代表商会全体会员及新一届领导班子，向每一位关心、支持商会发展的金华市民，致以最诚挚的感谢和最美好的新春祝福！</p><p>12年风雨兼程，从初生萌芽到枝繁叶茂，金华市诸暨商会的成长始终与金华这座城市紧密相连。我们深知，这份成长离不开金华市民的包容与接纳——是你们用开放的胸怀欢迎我们这群异乡奋斗者，用真诚的善意给予我们信任与支持。无论是创业初期的迷茫，还是发展路上的挑战，市民们的每一次鼓励、每一份认可，都成为我们坚守初心、砥砺前行的动力源泉。这12年，我们不仅是商会发展的见证者，更是金华市民友善与热情的受益者。</p><p>如今，第三届新领导班子接过接力棒，既深感使命光荣，更觉责任在肩。我们将继续秉承“团结、务实、共赢、奉献”的商会宗旨，以“服务会员、回馈社会”为双翼，一方面为在金诸暨企业家搭建更广阔的平台，助力大家在金华这片热土深耕细作、创新发展；另一方面，也将积极发挥桥梁纽带作用，推动更多优质资源落地金华，为城市经济注入活力，用实际行动回报市民的厚爱。</p><p>新春是新的起点，也是新的希望。新一届领导班子将以更饱满的热情、更务实的作风，团结带领全体会员，与金华市民同心同向、携手并进。我们期待，在未来的日子里，能继续与大家共享发展机遇，共绘发展蓝图，让商会的“诸商力量”与金华的“城市温度”深度融合，共同书写互利共赢的新篇章！</p><p>值此新春佳节，衷心祝愿全体金华市民：新春快乐、身体健康、阖家幸福、万事如意！愿我们在这座充满活力的城市里，共迎春暖花开，共赴美好明天！</p><p class="end-words">——金华市诸暨商会 敬上</p>'
        }else if (this.$route.query.id == 3) {
            this.mp4_1.sources[0].src = require("../static/m3.mp4")
            this.mp4_1.poster = require("../static/m3.png")
           this.words = '<p>浙江明洁生活服务有限公司成立于2018年，注册资金1000万元整，2024年经上级政府部门审核后升为规上企业，是浙中地区首家推行智慧清洁模式的公司，在浙中地区已落地服务多种业态场景并取得成功。公司有签约制员工1200余人，本公司依托高科技的环保技术以全新的理念推出物业保洁外包、建筑物清洁、后勤托管等服务。主要经营范围为：园区、办公场所、商厦、医院、商场、大楼的长期保洁与单位后勤托管，路面清扫，垃圾清运，垃圾分类等业务。公司以“支持环保，美化城市，共创美好生活”为己任；以市场为导向，立足社会、贡献社会、服务社会、为保护人类的生态环境，构建和谐社会做出不懈的努力。</p>  <p class="the3_1">200 + 服务项目</p> <p class="the3_2">1200+ 员工</p> <p class="the3_3">100+在管服务项目</p> '
        }
        else if (this.$route.query.id == 4) {
            this.mp4_1.sources[0].src = require("../static/m4.mp4")
            this.mp4_1.poster = require("../static/m4.png")
            this.words = '<p class="title-words">尊敬的钓友及合作伙伴们：</p><p >在这辞旧迎新的美好时刻，佳钓尼以最真挚的祝福，向每一位热爱碧波、钟情钓趣的朋友，以及与我们并肩前行的合作伙伴，致以新春的问候与感谢！</p><p >过去一年，每一次挥竿的从容，每一份收获的喜悦，都因您的信任而意义非凡。我们始终坚守“匠心造好竿，诚意连四海”的初心，将专业与热忱注入每一件产品，用便捷服务连通天南地北的钓场。</p><p >2026，新程已启。愿我们继续携手，乘风破浪、鱼跃龙门——以科技赋能传统，以创新延续热爱。祝您在新的一年里：</p><p class="title-words"></p><p class="title-words">竿竿见喜，线线传鸿运；</p><p class="title-words">家中团圆暖，户外收获丰；</p><p class="title-words">事业如扬竿，步步展宏图！</p><p class="title-words">让我们共同期待，下一次扬竿，遇见更美的风景。</p><p class="title-words">新春快乐，阖家安康！</p>'
        }
          else if (this.$route.query.id == 5) {
            this.mp4_1.sources[0].src = require("../static/m5.mp4")
            this.mp4_1.poster = require("../static/m5.png")
            this.words = '<p class="title-words">尊敬的金华市民朋友们：</p><p >新春伊始，万象更新。值此2026丙午马年到来之际，金华市东阳商会向您致以最诚挚的新春祝福！</p><p >八载同行，感恩有您。在各级领导的关怀指导下，在葛炳灶会长及各位执行会长的带领下，我们商会始终秉持初心，汇聚今飞、万里扬、绿源等二十多家骨干企业，积极投身金华经济建设与社会公益。</p><p >过去一年，我们不仅在产业领域精耕细作，更为家乡引进企业，为市民解决急难愁盼问题，用实际行动回馈社会。这份温暖与责任，源于每一位会员的携手并肩，更离不开您的信任与支持。</p><p >金马奔腾，再启新程。新的一年，我们将继续发扬“抱团取暖、共谋发展”的精神，为建设更美好的金华贡献力量。</p><p >祝愿全体市民：</p><p class="title-words">新春快乐，阖家幸福！</p><p class="title-words">身体健康，万事如意！</p><p class="title-words">马年大吉，福暖四季！</p><p class="end-words">——金华市东阳商会 敬上</p>'       
         }
          else if (this.$route.query.id == 6) {
            this.mp4_1.sources[0].src = require("../static/m6.mp4")
            this.mp4_1.poster = require("../static/m6.png")
            this.words = '<p class="title-words">亲爱的金华市民朋友们： </p><br><p >金蛇辞旧岁，骏马啸长风。在这辞旧迎新的美好时刻，金华成泰农商银行向全市人民致以最诚挚的新春祝福！感谢您一直以来的信任与支持，与您携手走过又一个充满挑战与收获的年份。2025年，我行荣获“第七届全国文明单位”、全国“敬老文明号”等称号。</p><p>作为 乡村振兴的主办银行，我们深耕乡土，让金融活水润泽每一寸希望的田野； </p><p >作为 民营小微的伙伴银行，我们并肩同行，为实体经济注入源源不断的动能；</p><p >作为 普惠金融的主办银行，我们步履不停，将便捷服务送到千家万户的门前。</p><p >新的一年，我们将深入落实市委、市政府决策部署，筑牢“农商姓党”的政治属性，坚守“姓农、姓小、姓土”核心定位，深化“以客户为中心”的价值理念，将用更贴心的产品、更高效的体验、更温暖的陪伴，与您共绘幸福蓝图。</p><p >我们坚信，每一次真诚的握手、每一笔务实的金融支持、每一回暖心的服务，都在为这座城市的未来添砖加瓦。扎根金华大地，服务本土百姓，是我们不变的初心与使命。</p><p>2026年，愿以更坚定的步伐、更扎实的举措、更饱满的热情，与您同心同行，共赴山海，共启新程！</p><p >愿您在丙午马年： </p><p >身体健康，阖家幸福； </p><p >策马扬鞭，事业腾跃； </p><p >万事顺遂，心想事成。</p><br><p class="end-words">——金华成泰农商银行 敬上</p>'       
         }
         else if (this.$route.query.id == 7) {
            this.mp4_1.sources[0].src = require("../static/m7.mp4")
            this.mp4_1.poster = require("../static/m7.png")
            this.words = '<p class="title-words">尊敬的客户及合作伙伴们： </p><p >龙马精神，福满前程。值此马年新春来临之际，中国人寿金华分公司谨向您及家人致以最诚挚的节日问候和最美好的新春祝福！</p><p >过去一年，感恩有您一路同行。我们始终秉持“相知多年，值得托付”的承诺，与您共担风雨，为您守护安宁。在广大客户朋友的支持下，公司规模不断发展，总保费突破65亿元，稳居金华保险行业龙头。</p><p >新的一年，我们将继续以骏马奔腾之势，为您提供更专业、更温暖、更全面的保险服务。以匠心守初心，用真诚伴始终，全力守护您和家人的幸福安康，让未来每一步都走得更加踏实、更有底气。</p><p >愿我们在崭新的春天里，继续携手并肩，同创美好！</p><p >祝您及家人： </p><p >马年吉祥，身体健康，阖家欢乐，万事胜意！</p><p class="end-words">——中国人寿金华分公司 敬上</p>'       
         }
         else if (this.$route.query.id == 8) {
            this.mp4_1.sources[0].src = require("../static/m8.mp4")
            this.mp4_1.poster = require("../static/m8.png")
            this.words = '<p class="title-words">尊敬的金华市民朋友们： </p><p >大家好！</p><p >新元肇启，万象更新。在这辞旧迎新的美好时刻，金华婺城长湖湾置业有限责任公司携万固长湖湾·观云项目全体同仁，向一直以来关心、支持我们的金华市民朋友们，致以最诚挚的新春祝福和最美好的新年问候！</p><p >回首过往，感恩同行。正是因为有了您的选择与信任，如同温暖的灯火，照亮了我们前行的征程。每一次置业的信任托付，每一份对家园的美好期许，都化作我们不断精进、追求卓越的不竭动力。在此，我们衷心感谢您一路相伴，是您的认可，让我们更有底气去匠筑品质人居。</p><p >新程如骏，共筑人居华章。</p><p >值此丙午马年新春，我们承诺将继续秉持“金质匠心，品质生活”的核心价值观。万固长湖湾·观云项目，作为长湖湾四代住宅的代表作，以超100%的得房率、户户享庭院的独特设计，致力于为您和家人营造“生活万般甜”的理想居所。 </p><p >新的一年，我们将以更加饱满的匠心和更加专业的服务，与您携手并肩，共同开启一段充满美好与憧憬的人居新程，共筑幸福家园！</p><p>最后，祝愿各位市民朋友：</p><p class="title-words">事业登峰造极，马到功成！</p><p class="title-words">阖家幸福美满，岁岁无忧！</p><p class="title-words">身体健康，万事顺意，马年大吉，安家乐业！</p><p class="end-words">——金华婺城长湖湾置业 敬上</p>'       
         }   else if (this.$route.query.id == 9) {
            this.mp4_1.sources[0].src = require("../static/m9.mp4")
            this.mp4_1.poster = require("../static/m9.png")
            this.words = '<p class="title-words">尊敬的客户及合作伙伴们： </p><p >新春将至，我们向您及家人致以最诚挚的祝福。</p><p >祝您：马跃新程，路路亨通；鞍驮锦绣，岁岁昌隆。</p><p >浙江金义融资租赁有限公司（金义租赁）成立于2022年11月，注册资本3亿元，是由金华市金融控股投资有限公司、金华市现代服务业投资发展有限公司、浙江金义田园智城科创有限公司共同出资的类金融机构，也是金华地区唯一的国有控股融资租赁法人主体。公司坐落于金华之心，专注于以设备为基础的金融租赁业务，涵盖售后回租、直接租赁、经营性租赁等。秉承“扎根地方、服务中小、行稳致远”的战略，金义租赁充分发挥融资租赁优势，助力实体经济和民生工程。成立三年来，公司已为数十家企业提供服务，截至2025年12月底，累计投放超23亿元，租赁资产总额超13亿元，实现了快速发展。</p><p >如需合作，请联系：</p><p >电话：81720018、81720010</p><p>邮编：321000</p><p>地址：浙江省金华市婺城区李渔路1313号金华之心6号楼A座9楼。</p><p class="end-words">——浙江金义融资租赁有限公司 敬上</p>'       
         }  else if (this.$route.query.id == 10) {
            this.mp4_1.sources[0].src = require("../static/m10.mp4")
            this.mp4_1.poster = require("../static/m10.png")
            this.words= '<p class="title-words">尊敬的客户及合作伙伴们：</p><p>在这辞旧迎新的美好时刻，浙江智仁律师事务所向您及家人致以诚挚的问候与祝福！</p><p>回望过去一年，感谢您始终如一的支持与信任。每一次合作的落地、每一回沟通的往来，都让我们的脚步更稳、方向更清晰；那些一起完成的目标与成果，也成为我们共同珍藏的记忆。正因有您的陪伴与提醒，我们才能不断精进，持续向前。</p><p> 新的一年，我们将以更饱满的热忱、更专业的行动，坚守“创新、卓越、共赢”的核心价值观，持续为您奉上更优质的产品与服务。望与您策马并肩、同心同行，在新程中共迎机遇、共克挑战，让愿景落地生花，合作步履铿锵、行稳致远！</p><p>衷心祝愿您新年安康、阖家幸福，事业骏顺、万事胜意！</p><p class="end-words">——浙江智仁律师事务所 敬上</p>'
         }else if (this.$route.query.id == 11) {
            this.mp4_1.sources[0].src = require("../static/m11.mp4")
            this.mp4_1.poster = require("../static/m11.png")
            this.words= '<p class="title-words">尊敬的客户与合作伙伴们：</p><p>岁序更替，万象启新。国网（金华）综合能源服务有限公司致力于提供高效、低碳的综合能源服务。值此新春，谨向关心支持我们的各界朋友致以诚挚感谢与美好祝福！祝大家新春快乐、阖家安康，共赴绿色低碳新征程！</p><p>过去一年，我们锚定“绿色化、数字化、市场化”发展方向，以“安全、清洁、高效、低碳”为用能目标，深耕能源交易、能源服务、能源投资三大领域。从市场化售电润泽万千企业，到绿电绿证赋能低碳转型；从虚拟电厂智慧聚合能源，到阳光掌柜精准贴心服务；从建筑节能推动低碳先行，到能碳业务擘画兴业蓝图——我们始终秉持“为客户创造经济效益，为社会创造绿色价值”的使命，致力于提供“省时、省心、省钱、省力”的综合能源管家服务，助力“3060”双碳目标实现。</p><p> 展望新年，我们将继续秉持“数字牵引+绿色低碳”发展理念，以龙马精神奋楫前行，以能碳协同勇担新使命。让我们携手并肩，共创绿色能源未来！</p><p class="end-words2">——国网(金华)综合能源服务有限公司  <br> 敬上</p>'   
         }else if (this.$route.query.id == 12) {
            this.mp4_1.sources[0].src = require("../static/m12.mp4")
            this.mp4_1.poster = require("../static/m12.png")
            this.words= '<p class="title-words">尊敬的客户与合作伙伴们：</p><p>浙江移和农业发展有限公司投资经营智慧农业、古建筑和文旅等行业。近年来，积极推动智慧农业和乡村数字建设，加快农业全产业链数字化转型。致力于现代农业发展模式创新，创建现代农业共富产业经营模式。于2016年建设位于浙江•武义的 “浙江省首个菌光互补示范项目”；于2022年签约并申请位于 衢州•常山的“省级农村产业融合发展示范园”；于2023年投资建设浙江·武义云在兮新农人空间、露营基地；于2024年投资升级浙江·武义移和文创园。从安徽、江西、浙江等地保护并迁建200余栋古名居建筑，被列为“浙江省重点项目”，积极探索历史文化遗产与城市高质量发展的有机结合，实现文旅深度融合，谋求可持续发展。</p>   '
        }else if (this.$route.query.id == 13) {
            this.mp4_1.sources[0].src = require("../static/m13.mp4")
            this.mp4_1.poster = require("../static/m13.png")
            this.words='<p class="title-words">尊敬的客户及合作伙伴们：</p><p>在这辞旧迎新的美好时刻，义乌市文化用品行业协会向您及家人致以诚挚的问候与祝福！</p><p>回望过去一年，感谢您始终如一的支持与信任。每一次合作的落地、每一回沟通的往来，都让我们的脚步更稳、方向更清晰；那些一起完成的目标与成果，也成为我们共同珍藏的记忆。正因有您的陪伴与提醒，我们才能不断精进，持续向前。</p><p> 新的一年，我们将以更饱满的热忱、更专业的行动，坚守“创新、卓越、共赢”的核心价值观，持续为您奉上更优质的产品与服务。望与您策马并肩、同心同行，在新程中共迎机遇、共克挑战，让愿景落地生花，合作步履铿锵、行稳致远！</p><p>衷心祝愿您新年安康、阖家幸福，事业骏顺、万事胜意！</p><p class="end-words">——义乌市文化用品行业协会 敬上</p>'
        }
       
       
       
        window.addEventListener("scroll", this.scrolling)
        this.androidplay()
        window.addEventListener("WeixinJSBridgeReady", function onBridgeReady() {


            document.getElementById('audio').volume = 0.2;
            document.getElementById('audio').play();
            document.removeEventListener('WeixinJSBridgeReady', onBridgeReady);

        }, false)
        setTimeout(() => {
            this.thewords = true
        }, 2000);

        setTimeout(() => {
            this.show = true
        }, 5000);
        setTimeout(() => {
            this.showmp4 = true
        }, 4000);
    }

}
</script>

<style lang="less">
.home {
    background: url("../static/homebg.jpg") no-repeat;
    background-size: 100% 100%;
    width: 100%;
    height: 1100px;
    position: relative;
    overflow: hidden;
    .music {
        position: fixed;
        width: 40px;
        height: 40px;
        top: 65px;
        right: 20px;
        background: url("../static/music.png") center no-repeat;
        background-size: 100% 100%;
        z-index: 10;

        &.zhuan {
            animation: turn 2s linear infinite;

            @keyframes turn {
                0% {
                    -webkit-transform: rotate(0deg);
                }

                25% {
                    -webkit-transform: rotate(90deg);
                }

                50% {
                    -webkit-transform: rotate(180deg);
                }

                75% {
                    -webkit-transform: rotate(270deg);
                }

                100% {
                    -webkit-transform: rotate(360deg);
                }
            }
        }
    }

    .thegif {
        position: absolute;
        top: -40px;
        width: 100%;
    }

    .title {
        position: absolute;
        top: 70px;
        width: 280px;
        left: 50%;
        margin-left: -130px;
        animation: title_ani 2.5s ease 1 forwards;
        z-index: 5;

        @keyframes title_ani {
            0% {
                width: 360px;
                opacity: 0;

            }

            100% {
                width: 280px;
                opacity: 1;
            }
        }
    }

    .thewords {
        position: absolute;
        width: 180px;
        top: 190px;
        left: 50%;
        margin-left: -90px;

        animation: thewords_ani 2.5s ease 1 forwards;

        @keyframes thewords_ani {
            0% {

                opacity: 0;

            }

            100% {

                opacity: 1;
            }
        }
    }

    .words {
        font-size: 15px;
        width: 280px;
        text-indent: 2em;
        height: 350px;
        overflow: hidden;
        overflow-y: scroll;
        position: absolute;
        color: #797878;
        top: 530px;
        left: 50%;
        margin-left: -140px;
        text-align: justify;
        // font-family:KaiTi;
        font-family: '方正兰亭雅黑';
        animation: words_an 1s ease 1 forwards;


        @keyframes words_an {
            0% {

                opacity: 0;

            }

            100% {

                opacity: 1;
                transform: translate(0);
            }
        }

        .title-words {
            text-indent: 0em;
            
        }
        .center-words{
            text-align: center;
        }
        .end-words {
            text-align: right;
        }
         .end-words2 {
            text-indent: 0em;
            text-align: right;
        }
        .the3_1{
            margin-top: 20px;
            text-indent: 1em;
            color: #235da8;
            font-size: 19px;
        }
        .the3_2{
            text-indent: 2.5em;
            color: #235da8;
            font-size: 21px;
        }
        .the3_3{
            text-indent: 3.5em;
            color: #235da8;
            font-size: 23px;
            margin-bottom: 20px;
        }

    }

    .mp4-1 {
        position: absolute;
        width: 300px;
        height: 180px;
        top: 320px;
        left: 50%;
        margin-left: -150px;

        animation: mp4_ani 2s ease 1 forwards;

        @keyframes mp4_ani {
            0% {

                opacity: 0;

            }

            100% {

                opacity: 1;
            }
        }
    }

    .vjs-poster{
        background-color: transparent;
    }

    .ewm {
        width: 100px;
        position: absolute;
        top: 895px;
        left: 50%;
        margin-left: -50px;
    }

    .tips {
        position: absolute;
        top: 1000px;
        font-size: 14px;
        width: 200px;
        text-align: center;
        left: 50%;
        margin-left: -100px;
    }

    .logo1 {
        position: absolute;
        height: 30px;
        top: 1045px;
        left: 120px;
    }

    .logo {
        position: absolute;
        height: 28px;
        top: 1044px;
        left: 200px;
    }
}
</style>